import { useMemoizedFn } from 'ahooks';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Form, Input, Select, Table } from 'tdesign-react';
import { connect } from 'react-redux';
import { getTopicAclInfo } from '@/services/kafkaPermissionsService';
import useTable from '@/hooks/useTable';
import { toTsOptions } from '@/utils/common';
import { fetchResourceTypeOptions } from '@/slices/kafkaPermissionsSlice';

const { FormItem } = Form;

function KafkaACLs({ commonProps, options, fetchResourceTypeOptions }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  const columns = [
    {
      colKey: 'principal',
      title: 'Principal',
      width: 120,
    },

    {
      colKey: 'permission',
      title: 'Permission',
    },
    {
      colKey: 'patternType',
      title: 'Pattern Type',
    },
    {
      colKey: 'operations',
      title: 'Operations',
    },
    {
      colKey: 'resource',
      title: 'Resource',
    },
    {
      colKey: 'host',
      title: 'Host',
    },
  ];
  const loadData = useMemoizedFn(async (params = {}) => {
    const { data } = await getTopicAclInfo({ ...params, clusterName, resource: commonProps.topic });
    setData(data);
  });

  const { config, header, setData, doSearch } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        <FormItem name='principal'>
          <Input placeholder='Principal' clearable />
        </FormItem>
        <FormItem name='resourceType'>
          <Select options={toTsOptions(options)} placeholder='选择 Resource Type' clearable />
        </FormItem>
      </>
    ),
  });

  useEffect(() => {
    doSearch();
    fetchResourceTypeOptions(clusterName);
  }, [doSearch, fetchResourceTypeOptions, clusterName]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

export default connect(
  (state) => ({
    options: state.kafkaPermissions.resourceTypeOptions,
  }),
  {
    fetchResourceTypeOptions,
  },
)(KafkaACLs);

const Root = styled.div`
  padding-top: 18px;
`;
